import { Box } from '@mui/material';
import { useMemo } from 'react';

import Text from '@root/components/v2/ui-elements/Text';

import { ReactComponent as BetaIcon } from '@assets/img/environment-tags/beta.svg';
import { ReactComponent as DevIcon } from '@assets/img/environment-tags/dev.svg';
import { ReactComponent as HfIcon } from '@assets/img/environment-tags/hf.svg';
import { ReactComponent as ProdIcon } from '@assets/img/environment-tags/prod.svg';
import { ReactComponent as TestIcon } from '@assets/img/environment-tags/test.svg';

import './style.scss';
import Tooltip from '@root/components/v2/ui-elements/Tooltip';

function CountTooltip({
  showFirst = true,
  riskExpandTable = false,
  riskExpandRegionTable = false,
  labels,
  fontSize,
  fontWeight,
  borderless,
  visibleLabelClassName,
  visibleCountClassName,
  containerStyle = {},
  visibleLabelStyle = {},
}) {
  const VisibleLabelIcon = useMemo(() => {
    const visibleLabel = labels?.[0] || null;

    const icons = {
      Production: ProdIcon,
      prod: ProdIcon,
      'Hot Fix': HfIcon,
      'Hot-Fix': HfIcon,
      Staging: BetaIcon,
      staging: BetaIcon,
      Testing: TestIcon,
      test: TestIcon,
      Development: DevIcon,
      dev: DevIcon,
    };

    return icons[visibleLabel];
  }, [labels]);

  if (!labels || !labels.length) return null;

  return (
    <div className={`CountTooltip2 ${borderless ? 'CountTooltip2-Borderless' : ''}`} style={{ ...containerStyle }}>
      {showFirst && (
        <Tooltip isIcon={true} title={<div className="CountTooltip2__Content">{labels[0]}</div>} arrow>
          {VisibleLabelIcon ? (
            <Box>
              <VisibleLabelIcon />
            </Box>
          ) : (
            <Text
              element="div"
              fontSize={fontSize || '11px'}
              fontWeight={fontWeight || '400'}
              className={`CountTooltip2__VisibleLabel SingleLine ${visibleLabelClassName || ''}`}
              style={{ ...visibleLabelStyle, fontWeight: 400 }}>
              {labels[0]}
            </Text>
          )}
        </Tooltip>
      )}
      {labels.length > 1 ? (
        <Tooltip
          isIcon={true}
          title={
            <div className="CountTooltip2__Content">
              {labels?.slice(1)?.map(label => (
                <Text
                  className="CountTooltip2__Item"
                  fontSize={fontSize || '11px'}
                  fontWeight={fontWeight || '400'}
                  key={label}>
                  {riskExpandTable || riskExpandRegionTable ? `${label.Key}: ${label.Value}` : label}
                </Text>
              ))}
            </div>
          }
          arrow>
          <Text
            element="span"
            fontSize={fontSize || '11px'}
            fontWeight={fontWeight || '400'}
            className={`CountTooltip2__CountContainer ${visibleCountClassName || ''}`}>
            +{labels.length - 1}
          </Text>
        </Tooltip>
      ) : null}
    </div>
  );
}

export default CountTooltip;
